import _ from 'lodash';

export default function flatMapArrayLike(col, fnOrProp) {
  const array = _.map(col, fnOrProp);
  const result = [];
  for (const value of array) {
    if (isArrayLike(value)) {
      result.push(...value);
    } else {
      result.push(value);
    }
  }
  return result;
}

const isArrayLike = value => {
  return _.get(value, Symbol.iterator) && !_.isString(value);
};
